import { InfoCircleOutlined } from "@ant-design/icons";
import { Alert, Empty, message, PageHeader, Spin, Table } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TabbedDynamicTable, TagItem } from "../../../Components/Items";
import { colorPaleta } from "../../../Components/TagItem";
import PlanEmpresa, { dinero, Indicador, TituloSeccion } from "./PlanEmpresa";

class MiPlanBiwo extends Component {
    state = { loading: true, plan: null, version: 0 };

    componentDidMount() {
        this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        axios.post("miPlanBiwo/selectMiPlan", {}, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) this.setState((s) => ({ loading: false, plan: res.data.data, version: s.version + 1 }));
            else {
                this.setState({ loading: false });
                message.error(res.data.message || "No se pudo consultar tu plan");
            }
        });
    };

    enviar = (ruta, body) => {
        this.setState({ loading: true });
        axios.post("miPlanBiwo/" + ruta, body, { headers: this.props.headersToken }).then((res) => {
            if (res.data.success === 2) {
                message.success(res.data.message);
                this.consultar();
            } else {
                this.setState({ loading: false });
                message.error(res.data.message || "No se pudo actualizar tu plan");
            }
        });
    };

    renderResumen() {
        const { plan } = this.state;
        const modulosContratados = new Map();
        plan.empresas.forEach((empresa) => empresa.modulos.filter((m) => m.activo).forEach((m) => modulosContratados.set(m.clave, m.nombre)));
        const columns = [
            {
                title: "Empresa",
                dataIndex: "nombre",
                width: 220,
                filters: plan.empresas.map((empresa) => ({ text: empresa.nombre, value: String(empresa._id) })),
                onFilter: (valor, fila) => fila.key === valor,
                render: (nombre) => <b>{nombre}</b>,
            },
            {
                title: "Contratado",
                dataIndex: "contratados",
                filters: [...modulosContratados].map(([clave, nombre]) => ({ text: nombre, value: clave })),
                onFilter: (valor, fila) => fila.contratados.some((m) => m.clave === valor),
                render: (contratados) =>
                    contratados.length ? (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                            {contratados.map((m) => (
                                <TagItem key={m.clave} cyan style={{ margin: 0 }}>
                                    {m.nombre}
                                </TagItem>
                            ))}
                        </div>
                    ) : (
                        <span style={{ color: "#8c8c8c" }}>Sin módulos contratados</span>
                    ),
            },
            { title: "Este periodo (sin IVA)", dataIndex: "total", align: "right", width: 180, sorter: (a, b) => a.total - b.total, render: (valor) => <b>{dinero(valor)}</b> },
        ];
        const dataSource = plan.empresas.map((empresa) => ({
            key: String(empresa._id),
            nombre: empresa.nombre,
            contratados: empresa.modulos.filter((m) => m.activo),
            total: empresa.partidas.reduce((s, p) => s + p.importe, 0),
        }));
        return <Table size="small" className="custom-small-table" pagination={false} columns={columns} dataSource={dataSource} scroll={{ x: "max-content" }} />;
    }

    renderIndicadores() {
        const { plan } = this.state;
        return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 12 }}>
                <Indicador
                    titulo={`Periodo ${plan.periodicidad}`}
                    valor={`${moment(plan.periodo.inicio).format("DD/MM/YYYY")} – ${moment(plan.periodo.fin).format("DD/MM/YYYY")}`}
                    color={colorPaleta("azul")}
                    chico
                />
                <Indicador titulo="Total del periodo (sin IVA)" valor={dinero(plan.total)} color={colorPaleta("cyan")} />
                {plan.totalLista > plan.total && <Indicador titulo="Ahorras" valor={dinero(plan.totalLista - plan.total)} color={colorPaleta("verdeNatural")} />}
                <Indicador titulo="Empresas" valor={plan.empresas.length} color={colorPaleta("lila")} />
            </div>
        );
    }

    render() {
        const { plan, loading, version } = this.state;
        return (
            <>
                <PageHeader
                    title="Mi plan BIWO"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={plan && (plan.cobroActivo ? <TagItem verdeNatural>Plan configurado</TagItem> : <TagItem gris>Plan sin configurar</TagItem>)}
                />
                <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                    <Spin spinning={loading}>
                        {!plan ? (
                            <Empty description={loading ? "Cargando..." : "Sin información"} />
                        ) : (
                            <>
                                {this.renderIndicadores()}
                                {plan.generales.length > 0 && (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
                                        {plan.generales.map((p, i) => (
                                            <TagItem key={i} gris style={{ margin: 0 }}>
                                                {p.nombre}: {p.cantidad} × {dinero(p.precioUnitario)} = <b>{dinero(p.importe)}</b>
                                            </TagItem>
                                        ))}
                                        <span style={{ fontSize: 12, color: "#8c8c8c", alignSelf: "center" }}>sin IVA</span>
                                    </div>
                                )}
                                {!plan.cobroActivo && (
                                    <Alert type="info" showIcon style={{ marginBottom: 12, borderRadius: 6 }} message="Tu plan todavía no está configurado con BIWO; para hacer cambios contáctanos." />
                                )}
                                <TituloSeccion>Resumen por empresa</TituloSeccion>
                                {this.renderResumen()}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, margin: "16px 0 8px" }}>
                                    <TituloSeccion style={{ margin: 0 }}>Módulos por empresa</TituloSeccion>
                                    <span style={{ fontSize: 12, color: "#8c8c8c" }}>
                                        <InfoCircleOutlined /> Para bajar de paquete o dar de baja un módulo, pídelo a BIWO.
                                    </span>
                                </div>
                                <TabbedDynamicTable
                                    tabs={plan.empresas.map((empresa) => ({
                                        key: String(empresa._id),
                                        label: empresa.nombre,
                                        customContent: <PlanEmpresa key={`${empresa._id}-${version}`} empresa={empresa} plan={plan} onEnviar={this.enviar} />,
                                    }))}
                                />
                            </>
                        )}
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(MiPlanBiwo);
